import React from "react";

import { Grommet } from "grommet";
import { hpe } from "grommet-theme-hpe";
import AppRoutes from "./routes/AppRoutes";
import { Provider } from "react-redux";
import { AuthProvider } from "./contexts/AuthContext";
import store from "./redux/store/store";

function App() {
  return (
    <Provider store={store}>
      <Grommet full theme={hpe}>
        <AuthProvider>
          {/* <PageLayout> */}
          <AppRoutes />
          {/* </PageLayout> */}
        </AuthProvider>
      </Grommet>
    </Provider>
  );
}

export default App;
